import React from "react";
import PropTypes from "prop-types";
import CompleteTick from "wonderbly-components/lib/CompleteTick";
import RichText from "../../Prismic/RichText";
import cx from "classnames";
import "./CanvasDrawerMessage.scss";

const CanvasDrawerMesssage = (props) => {
  if (!props.message) {
    return null;
  }
  return (
    <div
      className={cx("canvas-drawer-message", {
        "canvas-drawer-message--hidden": !props.visible,
      })}
    >
      <div className="canvas-drawer-message-wrapper">
        <CompleteTick ticked />
        <div className="canvas-drawer-massage-content">
          {props.message && <RichText fields={props.message} />}
        </div>
      </div>
    </div>
  );
};

CanvasDrawerMesssage.propTypes = {
  visible: PropTypes.bool.isRequired,
  message: PropTypes.array,
};

export default CanvasDrawerMesssage;
